/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit'
import { ProjectsAPI } from 'controllers/Projects/ProjectsAPI'
import { NavigateFunction } from 'react-router-dom'
import { ShowException } from 'store/Application/appActions'
import { RootAppState } from 'store/configureStore'
import { getContext } from 'store/getContext'
import { UnloadProjectList } from 'store/ProjectList/asyncActions/unloadProjectList'
import { subscribeToProjectOperationsLogs } from './subscribeToProjectOperationsLogs'
import { subscribeToProjectNotifications } from './subscribeToUpdates'

export const fetchProject = createAsyncThunk<any, any, { state: any }>(
  'project/fetchProject',
  async (
    {
      projectId,
      navigateFunc,
    }: { projectId: string; navigateFunc?: NavigateFunction },
    thunkAPI
  ) => {
    try {
      const { partyId: organizationId } = getContext(
        thunkAPI.getState as () => RootAppState
      )

      const project = await new ProjectsAPI(organizationId).GetProjectInfo(
        projectId
      )

      const projectUpdateGroupName = `${projectId}_${
        project.isBuyingPartyView ? 'buyers' : 'sellers'
      }`
      const operationsGroupName = `${projectId}_operations_${
        project.isBuyingPartyView ? 'buyers' : 'sellers'
      }`

      const checkConnectionGroup = (groupName: string) =>
        (thunkAPI.getState() as RootAppState).connection.groups?.includes(
          groupName
        )

      if (
        !checkConnectionGroup(projectUpdateGroupName) ||
        !checkConnectionGroup(operationsGroupName)
      ) {
        thunkAPI.dispatch(UnloadProjectList())
        thunkAPI.dispatch(
          subscribeToProjectNotifications(projectUpdateGroupName)
        )
        thunkAPI.dispatch(subscribeToProjectOperationsLogs(operationsGroupName))
      }

      return project
    } catch (err) {
      ShowException('project', err)

      if (
        err['message']?.toLowerCase() === 'action not allowed' &&
        navigateFunc
      ) {
        navigateFunc?.('/app/workspaces', {
          state: { returnUrl: '/app/project/' + projectId },
        })
      } else {
        navigateFunc ? navigateFunc('/app') : window.location.replace('/app')
      }

      return Promise.reject(err)
    }
  }
)
